class AuthorController {
    constructor($scope,$state,$sce,AuthorAPI,CollectionAPI,$filter, message,userInfo,$stateParams, pageTitle, $timeout, fancyboxService) {
        "ngInject";
        $scope.unavailableImages = {};
        this.error = false;
        this.AuthorAPI = AuthorAPI;
        this.pageTitle = pageTitle;
        this.$timeout = $timeout;
        this.$filter=$filter;
        this.$sce = $sce

        this.articles = [];
        this.images = [];

        this.pageSize = 15;
        this.pageCount = 0;
        this.page = 1;

        this.type = 'articles';
        this.order = 'hottest';
        this.$state = $state;
        this.message = message;
        this.userInfo = userInfo;
        this.CollectionAPI=CollectionAPI;
        this.userInfo.setUser(this.appUser);


        let self = this;

        if (!$stateParams.id) {
            this.error = true;
            return;
        }

        this.loadAuthor($stateParams.id);

        this.tabs = [
            {
                name: self.$filter('translate')('page-author-text008'),
                click: () => {
                    self.page = 1;
                    self.type = 'articles';
                    self.loadOriginals();
                },
                active: true
            },
            {
                name: self.$filter('translate')('page-author-text009'),
                click: () => {
                    self.page = 1;
                    self.type = 'images';
                    self.loadOriginals();
                }
            }
        ];

        this.fancyboxOptions = fancyboxService.getOptions((title, currentArray, currentIndex, currentOpts) => {
            return '<div class="image-description">' +
                '<div class="image-title">' + title + '</div>' +
                '<div class="description-content">' + self.images[currentIndex].description + '</div>' +
                '</div>'
        });

    }

    switchOrder(order,page) {
        this.order=order;
        this.page=page;
        this.loadOriginals();
    }

    loadAuthor(id) {

        let self = this;
        this.mediaAccounts = {
            weixin: '',
            weibo: '',
            toutiao: ''
        }
        const mediaNames = [
            '',
            'weixin',
            'weibo',
            'toutiao'
        ];
        this.AuthorAPI.one(id).get().then(
            (author) => {
                self.author = author;
                self.pageTitle.setTitle(author.pseudonym);
                self.pageCount = Math.ceil(self.author.article_count / self.pageSize);

                author.user_media_accounts.forEach(e => {
                    this.mediaAccounts[mediaNames[e.account_type]] = e.address;
                })
                self.loadOriginals();
            },
            () => {
                self.error = true;
            }
        );
    }

    loadOriginals() {
        let self = this;
        
        this.AuthorAPI.one(this.author.id).one(this.type).get(
          {'page': this.page, 
            'order': this.order,
            'pageSize': this.pageSize,
              ...(this.searchText ? {q: this.searchText}:{})
          }).then(
            (originals) => {

                if (self.type == 'articles') {
                    self.articles = originals.data;
                } else {
                    self.images = originals.data;

                    self.$timeout(() => {
                        $(".yb-view-btn").fancyboxPlus(self.fancyboxOptions);
                    });
                }
                self.pageCount = Math.ceil(originals.total / self.pageSize);
                self.total = originals.total
                if(!self.userInfo.isGuest() && originals.length){
                    self.collection_check(self.type=='articles'?1:2,originals)
                }

            },
            () => {
                this.error = true;
            }
        );
    }

    loadPage(page) {
        this.page = page;
        this.loadOriginals();
    }
    collection(originals,type){
        if(this.userInfo.isGuest()){
            this.$state.go('app.face.index.user.form.login');
            return;
        }
        let self = this;
        originals.collection_loading=true;
        let api=this.CollectionAPI;
        if(originals.collectStatue){
            api.one().remove({resource_type_id: type, resource_id: originals.id}).then(
                () => {
                    originals.collection_loading = false;
                    self.message.success(self.$filter('translate')('page-author-text010'));
                    originals.collectStatue=false
                },
                (response) => {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                }
            );
        }else{
            api.post({resource_type_id: type, resource_id: originals.id}).then(
                () => {
                    originals.collection_loading = false;
                    self.message.success(self.$filter('translate')('page-author-text011'));
                    originals.collectStatue=true
                },
                (response) => {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                }
            );
        }

    }
    collection_check(type,originals){
        let ids=originals.map(function (item) {
                    return item.id
        });
        this.CollectionAPI.one('check').customPOST({resource_type_id: type, resource_ids: ids}).then(
            (res) => {
                //获取已收藏的数据
                let collectArr=res.data.filter((item)=>{
                    return item.is_active===1
                });
                collectArr && collectArr.forEach((collectItem)=>{
                    originals.forEach((originalItem)=>{
                        if(originalItem.id===collectItem.resource_id){
                            originalItem.collectStatue=true;
                            return true;
                        }
                    })
                })
            },
            (err) => {

            }
        );
    }
    $onInit(){
        //如果文章作者即用户本人 跳转到我的作品
        if(this.appUser && this.$state.params.id==this.appUser.uuid){
            this.$state.go('app.home.originals.articles');
            return;
        }
    }

    orderSearch() {
        this.loadOriginals()
    }
}

export default AuthorController;



// WEBPACK FOOTER //
// ./src/app/components/page/author/author.controller.js